var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFlagSen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_587",
    "data-name": "Ret\\xE2ngulo 587",
    width: 60,
    height: 60,
    transform: "translate(2242 3649)",
    fill: "#fff",
    opacity: 0.41
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "flag_SEN",
    transform: "translate(-2242 -3649)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "flag_senegal",
    transform: "translate(2220.454 3649)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_809",
    "data-name": "Grupo 809",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_468",
    "data-name": "Ret\\xE2ngulo 468",
    width: 34.286,
    height: 60,
    fill: "#378542"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_469",
    "data-name": "Ret\\xE2ngulo 469",
    width: 34.284,
    height: 60,
    transform: "translate(34.286)",
    fill: "#f8f04d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_470",
    "data-name": "Ret\\xE2ngulo 470",
    width: 34.286,
    height: 60,
    transform: "translate(68.57)",
    fill: "#d0002f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7010",
    "data-name": "Caminho 7010",
    d: "M374.815,11.618l2.268,6.968h7.308l-5.907,4.309,2.25,6.955-5.919-4.3-5.921,4.3,2.251-6.955-5.919-4.309h7.32Z",
    transform: "translate(-323.387 8.302)",
    fill: "#378542"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagSen);
export default __webpack_public_path__ + "static/media/flag_SEN.87a0e340ba2b524abb05be57c91a2ecb.svg";
export { ForwardRef as ReactComponent };